import { Box, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useLoginScreenStyle } from './hooks/useLoginScreenStyleHook'
import LogInMenu from './menus/LogInMenu'
import SingUpMenu from './menus/SingUpMenu'
import { useTranslation } from 'react-i18next'
import useAppSkin from '@/shared/hooks/useAppSkin'
import placeholder from '@/shared/assets/images/loginScreen.webp'
import { getGetFetchBootstrapsModule } from '@/shared/getContainer/getGetFetchBootstrapsModule'

const fetchBootstraps = await getGetFetchBootstrapsModule()

const LoginScreen = () => {
    const { appLoginScreenLogo } = useAppSkin()
    const { t: translate } = useTranslation()
    const {
        containerStyle,
        backgroundImageContainerStyle,
        logoStyle,
        subtitle1Style,
        headerStyle,
        contentStyle,
        verticalLineStyle,
        menusContainerStyle,
    } = useLoginScreenStyle()

    const backgroundImageStyle = {
        height: '100%',
        width: '4200px',
    }

    useEffect(() => {
        const getBootstraps = async () => {
            if (fetchBootstraps) {
                await fetchBootstraps()
            }
        }

        getBootstraps()
    }, [])

    return (
        <Box sx={containerStyle}>
            <Box sx={backgroundImageContainerStyle}>
                <img
                    style={backgroundImageStyle}
                    src={placeholder}
                    alt="background with multiple move posters"
                />
            </Box>

            <Box sx={contentStyle}>
                <Box sx={logoStyle}>
                    <img src={appLoginScreenLogo} alt="login screen logo" />
                </Box>
                <Typography sx={headerStyle}>
                    {translate('loginScreenSubtitle1')}
                </Typography>
                !!!!!!!!!!!!!AWS TEST!!!!!!!!!!!!!
                <Typography sx={subtitle1Style}>
                    {translate('loginScreenSubtitle2')}
                </Typography>
            </Box>
            <Box sx={menusContainerStyle}>
                <LogInMenu />
                <Box sx={verticalLineStyle} />
                <SingUpMenu />
            </Box>
        </Box>
    )
}

export default LoginScreen
